import { render, staticRenderFns } from "./alasim.vue?vue&type=template&id=df5b84a0&scoped=true&"
import script from "./alasim.vue?vue&type=script&lang=js&"
export * from "./alasim.vue?vue&type=script&lang=js&"
import style0 from "./alasim.vue?vue&type=style&index=0&id=df5b84a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5b84a0",
  null
  
)

export default component.exports